<template>
  <div class="faq">
    <h1>404, siden finnes ikke</h1>
    <FAQItem
      question="Uffda"
      answer="Send oss gjerne en tilbakemelding på hva du prøvde å gjøre."
    />
    <LinkButton
      href="https://forms.gle/r5aK33LX8SjcAuDs5"
      target="_blank"
      text="Gi tilbakemelding!"
    />
  </div>
</template>

<script>
import FAQItem from "@/components/FAQItem";
import Vue from 'vue'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

export default {
  name: "Error404",
  mounted() {
    // slette cookies om noe har skjedd feil - nyttig om dette har vært årsaken til problemer.
    this.deleteCookies();
  },
  components: {
    FAQItem,
  },
  methods: {
    deleteCookies() {
      return this.$cookies
        .keys()
        .forEach((cookie) => this.$cookies.remove(cookie));
    },
  },
};
</script>